import axios from 'axios'
import Cookie from 'js-cookie'
import { message } from 'antd'

const $axios = axios.create({
    timeout: 10 * 60 * 1000,
})

// 请求拦截
$axios.interceptors.request.use((config) => {
    config.headers = {
        ...config.headers,
        'Content-Type': 'application/octet-stream',
    }
    return config
}, error => {
    return Promise.reject(error)
})

// 响应拦截
$axios.interceptors.response.use(function (response) {
    return Promise.resolve(response.data)
}, error => {
    return Promise.reject(error)
})

export default $axios
